import React, {useState} from "react";
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {subscriptionServices} from "../../service/subscriptionService";
import Spinner from "../spinner/Spinner";
import {DialogActions, DialogContent, Alert, Button, Box} from "@mui/material";
import {AuthCard, AuthCardField, AuthLayout, AuthPaymentNote} from "./AuthDesign";

export default function AddPaymentMethod() {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async event => {
        event.preventDefault();
        setLoading(true);
        setErrorMsg("");

        if (!stripe || !elements) {
            return;
        }

        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardElement)
        });

        if (error) {
            setLoading(false);
            setErrorMsg(error?.message);
        } else {
            await subscriptionServices.updatePaymentMethod(paymentMethod?.id).then(() => {
                setLoading(false);
                document.location.replace("/");
            }).catch((error) => {
                setErrorMsg(error?.response?.data?.error);
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    return <AuthLayout session><AuthCard title="Add a payment method" description="Add your card to keep your campaigns running as your account grows.">
        {loading && <Spinner size={32} overComponentBox/>}
        <DialogContent>
            <Alert severity="warning" variant="filled">Your subscription plan has reached 250,000 events this month. Please add a payment method to continue.</Alert>
            {errorMsg !== "" && <Alert variant="outlined" severity="error">{errorMsg}</Alert>}
            <form id="add-payment-method" onSubmit={handleSubmit}>
                <Box sx={{fontWeight: 600, fontSize: 14, mt: 3}}>Card details</Box>
                <AuthCardField/>
            </form>
        </DialogContent>
        <DialogActions><Button fullWidth type="submit" form="add-payment-method" variant="contained" disabled={loading || !stripe || !elements}>
            Add payment method
        </Button></DialogActions>
        <AuthPaymentNote/>
    </AuthCard></AuthLayout>;
}
